
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { Reference } from '@sanity/types';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import SanityBlockContent from '~/components/Sanity/SanityBlockContent.vue';
import WatchVideoDialog from '~/components/Sanity/WatchVideoDialog.vue';
import ViewFigureDialog from '~/components/Sanity/ViewFigureDialog.vue';
import SanityMediaSlideshow from '~/components/Sanity/SanityMediaSlideshow.vue';

@Component({
  components: {
    SanityBlockContent,
    SanityMediaSlideshow,
    ViewFigureDialog,
    WatchVideoDialog,
  },
})
export default class ProjectMediaCarousel extends Vue {
  @Prop({ type: Array, default: [] })
  readonly items!: Reference[];
  @Prop(String) readonly title!: string;
  @Prop(String) readonly type!:
    | SanityDocumentSchema.VIDEO
    | SanityDocumentSchema.FIGURE;

  schemas = SanityDocumentSchema;

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }

  get width() {
    if (this.type === this.schemas.FIGURE) {
      return this.$vuetify.breakpoint.lgAndUp ? 280 : 164;
    }
    if (this.type === this.schemas.VIDEO) {
      return this.$vuetify.breakpoint.lgAndUp ? 497 : 253;
    }
  }

  get aspectRatio() {
    return this.type === this.schemas.FIGURE ? 1 : 16 / 9;
  }
}
